<template>
    <div :class="theme.listItem">
        <div :class="theme.label">
            <slot name="label" :label="label">{{label}}</slot>
        </div>
        <div>
            <slot></slot>
        </div>
    </div>
</template>
<script>
    import theme from './list.scss';

    export default {
        name: 'list-item',
        props: {
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        data() {
            return {
                label: this.$parent.getNextLabel(),
            }
        },
    }
</script>


// WEBPACK FOOTER //
// ListItem.vue?27dc919d